<template>
    <Menu />
    <section id="gracias">
        <Gracias />
    </section>
    <Footer />
</template>
<script>
import Menu from "@/components/menu/MenuPrincipal.vue";
import Footer from "@/components/footer/FooterPrincipal.vue";
import Gracias from "@/components/gracias/GraciasPrincipal.vue";

export default {
    name: "gracias",
    components: {
        Menu,
        Footer,
        Gracias        
    }
}
</script>